import { render } from "./HandlerPlayground.vue?vue&type=template&id=948761aa&scoped=true"
import script from "./HandlerPlayground.vue?vue&type=script&lang=js"
export * from "./HandlerPlayground.vue?vue&type=script&lang=js"

import "./HandlerPlayground.vue?vue&type=style&index=0&id=948761aa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-948761aa"]])

export default __exports__